module.exports = __webpack_public_path__ + "img/download.ae183b30.png";